<dialog [id]="modalDialogId" class="modal">
    <div
        class="modal-box p-5 max-w-[1000px] mobile:max-w-[90vw] max-h-[90dvh] overflow-y-auto flex flex-col justify-center items-center gap-5">
        <!-- Logo -->
        <img src="assets/icons/small-logo.svg" class="w-[80px] h-[80px]"
            alt="{{ 'shared.components.logo_alt' | transloco}}">
        <app-payment-method-update [clientSecret]="clientSecret" *ngIf="clientSecret"></app-payment-method-update>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button>Close</button>
    </form>
</dialog>